








import {Component, Vue} from "vue-property-decorator";
import XButton from "@/components/SimpleButton.vue";

@Component({
  components: {
    XButton,
  },
})
class Footer extends Vue {
  openAgreement() {
    const routeData = this.$router.resolve({name: 'agreement'});
    window.open(routeData.href, '_blank');
  }
}

export default Footer;
